const AiPatientNameModal = ({ onDismiss }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000]">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <svg
              className="h-6 w-6 text-teal-700 mr-3 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
              />
            </svg>
            <h3 className="text-lg font-semibold text-teal-800">
              AI Now Identifies Patient Names
            </h3>
          </div>

          <p className="text-gray-600 mb-3">
            Our AI automatically detects the patient's name from incoming calls
            and messages and populates the <strong>Full Name</strong> field on
            the lead — no manual entry needed.
          </p>
          <p className="text-gray-500 text-sm">
            You'll see names appear in the Full Name column as soon as the AI
            identifies them, helping your team work faster and keep records
            accurate.
          </p>

          <div className="flex justify-end mt-6">
            <button
              onClick={onDismiss}
              className="px-5 py-2 bg-teal-700 hover:bg-teal-800 text-white font-medium rounded-lg focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 transition duration-300"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiPatientNameModal;
